
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const CasseAutoBassin = () => {
  const services = [
    "Collecte et valorisation de VHU (Véhicules Hors d'Usage)",
    "Vente de pièces d'occasion",
    "Démolition de véhicules",
    "Recyclage automobile",
    "Récupération de métaux"
  ];

  return (
    <SiteDetailPage
      title="Casse Auto du Bassin - Démolition Automobile Viviez (12110)"
      description="Casse Auto du Bassin à Viviez - Spécialiste de la démolition automobile et du recyclage de véhicules hors d'usage en Aveyron. Pièces détachées d'occasion."
      proximityInfo="Centre de démolition automobile écologique dans le bassin de Decazeville, spécialisé dans le recyclage responsable des véhicules hors d'usage."
      address="La Grange LIEU DIT"
      postalCode="12110"
      city="Viviez"
      phone="05 65 43 03 78"
      email="contactgfe@groupefabre.com"
      services={services}
      coordinates={{ lat: 44.5580, lng: 2.2157 }}
      isMiniSite={true}
    />
  );
};

export default CasseAutoBassin;
